import * as React from "react";
import { Info, Wine, CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const pricingData = [{
  service: "Signature Body Treatment",
  note: "Full body therapeutic massage with forest-infused oils.",
  options: [{
    duration: "30 min",
    price: "$50"
  }, {
    duration: "60 min",
    price: "$70"
  }, {
    duration: "90 min",
    price: "$110"
  }]
}, {
  service: "Restorative Foot Therapy",
  note: "Deep pressure point relief and warm sage soak.",
  options: [{
    duration: "30 min",
    price: "$40"
  }, {
    duration: "60 min",
    price: "$70"
  }]
}, {
  service: "The Portland Combo",
  note: "Our most popular pairing of body and foot treatments.",
  options: [{
    duration: "30 min",
    price: "$50"
  }, {
    duration: "60 min",
    price: "$70"
  }]
}];
const faqData = [{
  question: "What is your cancellation policy?",
  answer: "We require at least 24 hours notice for cancellations. Appointments cancelled with less than 24 hours notice will be subject to a 50% service fee."
}, {
  question: "When should I arrive for my treatment?",
  answer: "Please arrive 15 minutes prior to your scheduled time to complete your wellness intake form and enjoy a cup of our herbal tea."
}, {
  question: "Are gratuities included in the price?",
  answer: "Gratuities are not included in our service prices. While never expected, they are always appreciated for exceptional service."
}, {
  question: "Do you offer gift certificates?",
  answer: "Yes, we offer digital and physical gift certificates for specific treatments or any dollar amount. They can be purchased online or in-spa."
}];
export default function ChutVrbovceACenik() {
  return <section data-section-id="257798" id="investment-in-self" className="bg-background text-foreground">
      <div className="bg-secondary text-secondary-foreground py-16 md:py-24 lg:py-32">
        <div className="container mx-auto px-4 md:px-6 max-w-5xl">
          
          <div className="text-center mb-12 md:mb-16">
            <Wine className="w-10 h-10 mx-auto mb-4 text-chart-2 opacity-80" />
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold mb-4 tracking-tight text-primary">
              Investment in Self
            </h2>
            <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans">Browse our treatments and find what works for you. Every session is hands-on, straightforward, and built around helping you feel better.</p>
          </div>

          <div className="mb-16 bg-background rounded-xl p-4 md:p-8 border border-border shadow-md">
            <Table className="text-foreground">
              <TableHeader className="border-border">
                <TableRow className="border-border hover:bg-transparent">
                  <TableHead className="text-muted-foreground font-sans text-base uppercase tracking-wider">Treatment</TableHead>
                  <TableHead className="text-muted-foreground font-sans text-base text-right md:text-left uppercase tracking-wider">Investment</TableHead>
                  <TableHead className="text-muted-foreground font-sans text-base hidden md:table-cell uppercase tracking-wider">Details</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {pricingData.map((group, groupIndex) => <React.Fragment key={groupIndex}>
                    {group.options.map((option, optionIndex) => <TableRow key={`${groupIndex}-${optionIndex}`} data-index={groupIndex * 10 + optionIndex} className="border-border hover:bg-muted/50 transition-colors">
                        <TableCell className="font-default font-semibold py-4 text-base text-primary">
                          {optionIndex === 0 ? group.service : ""}
                          <div className="md:hidden text-sm text-muted-foreground mt-1 font-normal font-sans">
                            {optionIndex === 0 ? group.note : ""}
                          </div>
                        </TableCell>
                        <TableCell className="py-4 text-right md:text-left whitespace-nowrap">
                          <span className="text-xl font-bold text-chart-2 font-default">{option.price}</span>
                          <span className="text-sm text-muted-foreground ml-1 font-sans">/ {option.duration}</span>
                        </TableCell>
                        <TableCell className="py-4 text-muted-foreground font-sans hidden md:table-cell">
                          {optionIndex === 0 ? group.note : ""}
                        </TableCell>
                      </TableRow>)}
                  </React.Fragment>)}
              </TableBody>
            </Table>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <Info className="w-6 h-6 text-chart-2" />
              <h3 className="font-default text-2xl font-semibold text-primary">
                Spa Etiquette & Policies
              </h3>
            </div>
            
            <Accordion type="single" collapsible className="w-full">
              {faqData.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
                  <AccordionTrigger className="text-left text-base md:text-lg font-default font-medium hover:text-chart-2 hover:no-underline transition-colors py-5">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground font-sans text-base leading-relaxed pb-5">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>

          <div className="mt-16 text-center">
            <Link to="/ContactPage">
              <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-sans font-semibold text-lg px-8 h-14 rounded-lg shadow-md"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-calendar-check w-5 h-5 mr-2" aria-hidden="true" data-ast-id="f:/src/pages/Services/sections/ChutVrbovceACenik.tsx|sig:vmpdna" data-ast-start="6317" data-ast-end="6359"><path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path><path d="m9 16 2 2 4-4"></path></svg>Book Today</Button>
            </Link>
          </div>

        </div>
      </div>
    </section>;
}